import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  currentMonthFunnel: {},
  currentMonthFunnelAreLoaded: false,
  lastMonthFunnel: {},
  lastMonthFunnelAreLoaded: false,
  firstMonthToCompare: {},
  firstMonthToCompareAreLoaded: false,
  secondMonthToCompare: {},
  secondMonthToCompareAreLoaded: false,
  target: {},
  targetIsLoaded: false,
  usersHistory: {},
  usersHistoryIsLoaded: false,
  totals: {},
  totalsIsLoaded: false,
  boHistory: {},
  boHistoryIsLoaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CURRENT_MONTH_FUNNELS[REQUEST]:
      return {
        ...state,
        currentMonthFunnel: {},
        currentMonthFunnelAreLoaded: false,
      };
    case ActionTypes.GET_CURRENT_MONTH_FUNNELS[SUCCESS]:
      return {
        ...state,
        currentMonthFunnel: action.data,
        currentMonthFunnelAreLoaded: true,
      };
    case ActionTypes.GET_CURRENT_MONTH_FUNNELS[FAILURE]:
      return { ...state, error: action.error, currentMonthFunnelAreLoaded: false };

    case ActionTypes.GET_LAST_MONTH_FUNNELS[REQUEST]:
      return {
        ...state,
        lastMonthFunnel: {},
        lastMonthFunnelAreLoaded: false,
      };
    case ActionTypes.GET_LAST_MONTH_FUNNELS[SUCCESS]:
      return {
        ...state,
        lastMonthFunnel: action.data,
        lastMonthFunnelAreLoaded: true,
      };
    case ActionTypes.GET_LAST_MONTH_FUNNELS[FAILURE]:
      return { ...state, error: action.error, lastMonthFunnelAreLoaded: false };

    case ActionTypes.GET_FIRST_MONTH_TO_COMPARE[REQUEST]:
      return { ...state, firstMonthToCompare: {}, firstMonthToCompareAreLoaded: false };
    case ActionTypes.GET_FIRST_MONTH_TO_COMPARE[SUCCESS]:
      return { ...state, firstMonthToCompare: action.data, firstMonthToCompareAreLoaded: true };
    case ActionTypes.GET_FIRST_MONTH_TO_COMPARE[FAILURE]:
      return { ...state, error: action.error, firstMonthToCompareAreLoaded: false };

    case ActionTypes.GET_SECOND_MONTH_TO_COMPARE[REQUEST]:
      return { ...state, secondMonthToCompare: {}, secondMonthToCompareAreLoaded: false };
    case ActionTypes.GET_SECOND_MONTH_TO_COMPARE[SUCCESS]:
      return { ...state, secondMonthToCompare: action.data, secondMonthToCompareAreLoaded: true };
    case ActionTypes.GET_SECOND_MONTH_TO_COMPARE[FAILURE]:
      return { ...state, error: action.error, secondMonthToCompareAreLoaded: false };

    case ActionTypes.GET_TARGET[REQUEST]:
      return { ...state, target: {}, targetIsLoaded: false };
    case ActionTypes.GET_TARGET[SUCCESS]:
      return { ...state, target: { ...state.target, ...action.data }, targetIsLoaded: true };
    case ActionTypes.GET_TARGET[FAILURE]:
      return { ...state, error: action.error, targetIsLoaded: false };

    case ActionTypes.GET_USERS_HISTORY[REQUEST]:
      return { ...state, usersHistory: {}, usersHistoryIsLoaded: false };
    case ActionTypes.GET_USERS_HISTORY[SUCCESS]:
      return { ...state, usersHistory: { ...action.data }, usersHistoryIsLoaded: true };
    case ActionTypes.GET_USERS_HISTORY[FAILURE]:
      return { ...state, error: action.error, usersHistoryIsLoaded: false };

    case ActionTypes.GET_TOTALS[REQUEST]:
      return { ...state, totals: {}, totalsIsLoaded: false };
    case ActionTypes.GET_TOTALS[SUCCESS]:
      return { ...state, totals: { ...action.data }, totalsIsLoaded: true };
    case ActionTypes.GET_TOTALS[FAILURE]:
      return { ...state, error: action.error, totalsIsLoaded: false };

    case ActionTypes.GET_BACKOFFICE_HISTORY[REQUEST]:
      return { ...state, boHistoryIsLoaded: false };
    case ActionTypes.GET_BACKOFFICE_HISTORY[SUCCESS]:
      return { ...state, boHistory: { ...action.data }, boHistoryIsLoaded: true };
    case ActionTypes.GET_BACKOFFICE_HISTORY[FAILURE]:
      return { ...state, error: action.error, boHistoryIsLoaded: false };

    case ActionTypes.RESET_DASHBOARD_LOADED_FLAGS:
      return {
        ...state,
        currentMonthFunnelAreLoaded: false,
        targetIsLoaded: false,
        lastMonthFunnelAreLoaded: false,
      };

    case ActionTypes.RESET_DASHBOARD_FIRST_AND_SECOND_MONTHS_FUNNELS:
      return {
        ...state,
        firstMonthToCompare: {},
        secondMonthToCompare: {},
        firstMonthToCompareAreLoaded: false,
        secondMonthToCompareAreLoaded: false,
      };

    default:
      return state;
  }
};

export default reducer;
